/**
 * Redux Reducer for Orders list and pagination.
 */

import { fromJS } from 'immutable';
import {
  SET_ORDERS_DATA,
  APPEND_ORDERS_DATA,
  SET_ORDERS_PAGINATION,
} from '../../actions/Orders';

const initialState = fromJS({
  list: [],
  pagination: {
    total: 0,
    limit: 5,
    offset: 0,
    hasMore: false,
  },
});

/**
 * Orders reducer
 *
 * @param {Immutable.Map} state - Current state
 * @param {Object} action - Redux action
 * @returns {Immutable.Map} - Updated state
 */
// eslint-disable-next-line default-param-last
const ordersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ORDERS_DATA: {
      // Replace orders list (initial load or refresh)
      return state.set('list', fromJS(action.payload));
    }

    case APPEND_ORDERS_DATA: {
      // Append orders to existing list (load more)
      const currentList = state.get('list');
      const newOrders = fromJS(action.payload);
      return state.set('list', currentList.concat(newOrders));
    }

    case SET_ORDERS_PAGINATION: {
      return state.set('pagination', fromJS(action.payload));
    }

    default:
      return state;
  }
};

export default ordersReducer;
